import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@rocketlane/ui';
import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex: 1 0 100%;
  align-items: center;
  margin-bottom: var(--spacing-05);
`;
export const FilterCriteriaWrapper = styled.div`
  max-height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
`;
export const FilterBoxWrapper = styled.div`
  min-width: 480px;
  display: flex;
  flex-direction: column;

  /** TODO: Move out of here @artfuldev */
  .ant-select-arrow {
    right: var(--spacing-05);
  }

  .ant-select {
    min-width: 120px;
    max-width: 240px;
  }

  .ant-select.ant-select-selection-item {
    padding: var(--spacing-03) var(--layout-01);
  }

  .ant-form-item-control-input {
    height: 40px;
  }

  .ozone-select__menu {
    z-index: 2;
  }
`;
export const AddFilterButton = styled(Button).attrs({
  size: 'small',
  variant: 'link',
  leftIcon: <FontAwesomeIcon icon={faPlus} size={12} />,
})`
  align-self: flex-start;
  margin-left: calc(-1 * var(--spacing-03));
  color: var(--gray-100);
  font-weight: var(--font-weight-bold);
  padding-left: var(--spacing-04);
`;
